<template>
  <div class="shared-step-editor-header">
    <div>
      <slot name="name" />
    </div>
    <div><slot name="editor" /></div>
    <div class="shared-step-editor-header__actions">
      <div class="shared-step-editor-header__status">
        <div class="shared-step-editor-header__enabled">Step{{ status ? ' enabled' : ' disabled' }}</div>
        <snappy-switch v-model="status" @input="$emit('status', status)"></snappy-switch>
      </div>
      <slot name="actions" />
    </div>
    <div class="shared-step-editor-header__close">
      <shared-step-editor-header-close :confirmation="confirmation" @confirm="$emit('exit')" />
    </div>
  </div>
</template>

<script>
import SharedStepEditorHeaderClose from './SharedStepEditorHeaderClose';
import SnappySwitch from '../../../../components/SnappySwitch.vue';

export default {
  components: {
    SharedStepEditorHeaderClose,
    SnappySwitch,
  },
  props: {
    confirmation: Boolean,
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    status: false,
  }),
  mounted() {
    this.status = this.enabled;
  },
};
</script>

<style scoped lang="scss">
.shared-step-editor-header {
  width: 100%;
  min-height: 74px;
  background: #66cccc;
  display: grid;
  grid-template-columns: max-content 1fr max-content 72px;
  grid-template-rows: 74px;
  gap: 20px;
  &__actions {
    display: flex;
    gap: 20px;
  }
  &__status {
    display: flex;
    align-items: center;
    margin-right: 20px;
  }
  &__enabled {
    display: inline-block;
    width: 100px;
    color: #ffffff;
  }
  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
